import type { Prototype } from "../prototype-types";

export const jasmineZhangPrototypes: Prototype[] = [
  {
    id: "jz-3d-pdp-images",
    name: "3D PDP images",
    path: "/jz/3d-pdp-images",
    description:
      "Per-variant 3D product images: brands add one per variant from the product-options table (upload a .glb/.usdz or pick 4 existing photos), approve the result before it goes live, and retailers open it from View in 3D on the PDP gallery.",
    owner: "Jasmine Zhang",
    createdAt: "2026-09-14",
    lastUpdated: "2026-09-14",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/jz-3d-pdp-images.png",
  },
];
